import credentails from './credentails'
import firebase from 'firebase/app'

export default firebase.initializeApp(credentails)
